import React, { useRef, useState } from "react";
import RequestAttachmentTable from "./components/RequestAttachmentTable";
import useRequestAttachment from "../actions/useRequestAttachment";
import DocumentConfirmationDialog from "~/components/confirmation-dialog/DocumentConfirmationDialog";
import TemporaryNotification from "~/components/toast-notification/AttachmentTemporaryNotification";
import Notification from "~/components/entities/notification/Notification";
import AttachmentSuccess from "~/components/toast-notification/AttachmentSuccess";
import "../requests.scss";
import BlobFilter from "~/components/BlobFilter";
import useAttachmentFilter from "~/hooks/useAttachmentFilter";
import FilterChip from "~/components/FilterChip";
import { useParams } from "react-router-dom";
const RequestAttachments = () => {
  const {
    attachment,
    loading,
    rows,
    totalRecords,
    onPageChange,
    handleOpenDialog,
    isDataAvailable,
    first,
    handleDeleteDocument,
    attachmentConfirmModal,
    setAttachmentConfirmModal,
    handleConfirmDelete,
    handleRestoreAttachment,
    temporaryMessage,
    isAttachmentLoader,
    successMessage,
    setSuccessMessage,
    restoreMessage,
    setRstoreMessage,
    setTemporaryMessage,
    requestdata,
    setRequestData,
    requestLoading,
    setReuestLoading,
    setFilterData,
    handleFilterChange,
    handleRemoveFilter,
    filterData,
    removeFnRef,
    selectedItems,
    data,
    filterLoading,
    error,
    onFilterChange,
    onFilterApply,
    onSortOrderChange,
    allData,
    filterPageChange,
    currentPage,
    page,
    fetchAttachment,
  } = useRequestAttachment();
  const { id } = useParams();
  return (
    <>
      <div className="flex flex-row-reverse mb-2">
        <BlobFilter
          onApply={({ value, group }) => {
            setFilterData(value);
          }}
          onRemove={(fn) => (removeFnRef.current = fn)}
          onFilterChange={({ value, grouped }) => {
            handleFilterChange(grouped);
          }}
          showEntity={false}
          showServiceLine={false}
          showYears={false}
          serviceLine={requestdata?.serviceData?.name}
          disabled={!isDataAvailable}
        />
      </div>
      <div className="mb-2">
        <FilterChip
          filterData={filterData}
          removeFilter={(id) => {
            handleRemoveFilter(id);
          }}
        />
      </div>
      <div className="attachment__tab--container">
        <Notification
          successMessage={successMessage}
          setSuccessMessage={setSuccessMessage}
        />
        <AttachmentSuccess
          successMsg={restoreMessage}
          setMessages={setRstoreMessage}
        />
        <TemporaryNotification
          onUndo={handleRestoreAttachment}
          successMsg={temporaryMessage}
          setMessages={setTemporaryMessage}
        />
        <RequestAttachmentTable
          attachment={selectedItems.length ? data : attachment}
          loading={selectedItems.length ? filterLoading : loading}
          rows={rows}
          totalRecords={selectedItems.length ? allData.length : totalRecords}
          onPageChange={
            selectedItems.length
              ? (e) => {
                  filterPageChange(e.page + 1);
                }
              : onPageChange
          }
          handleOpenDialog={handleOpenDialog}
          isDataAvailable={
            selectedItems.length ? allData.length : isDataAvailable
          }
          first={selectedItems.length ? page - 1 : first}
          handleAttachmentDelete={handleDeleteDocument}
          attachmentConfirmModal={attachmentConfirmModal}
          setAttachmentConfirmModal={setAttachmentConfirmModal}
          handleConfirmDelete={handleConfirmDelete}
          onSortOrderChange={
            selectedItems?.length ? onSortOrderChange : undefined
          }
          isFilterApplied={selectedItems.length}
          onRefetch={selectedItems?.length ? onFilterApply : fetchAttachment}
        />
        {attachmentConfirmModal && (
          <DocumentConfirmationDialog
            visible={attachmentConfirmModal}
            closeModal={() => setAttachmentConfirmModal(false)}
            handleSave={handleConfirmDelete}
            isLoader={isAttachmentLoader}
          />
        )}
      </div>
    </>
  );
};

export default RequestAttachments;
